import { FornecedorCotacaoPortalVm } from '../../core/models/supplier-portal.model'

// Espelha FornecedorCotacaoRespostaHelper do backend (status_cotacao_item).
export const STATUS_ITEM = {
  ENVIADO_FORNECEDOR: 1,
  VALOR_RECEBIDO: 2,
  CRIADO_TARIFARIO: 3,
  ENCERRADA: 4,
  RECUSADO_FORNECEDOR: 5,
} as const

// Status do cabeçalho (fornecedor_cotacao): 1 Criado, 2 Cancelado, 3 Enviado Fornecedor, 4 Finalizado.
// Só 3 aceita resposta — os POST devolvem 400 nos demais.
export const STATUS_COTACAO_ABERTA = 3

// O backend manda descricaoStatus cru ("Criado Tarifario", "Encerrada"). O contrato do portal pede
// que o fornecedor veja o desfecho — "Aceita"/"Encerrada" —, sem revelar que outro fornecedor
// ganhou o trecho nem por quanto.
export const LABEL_STATUS: Record<number, string> = {
  [STATUS_ITEM.ENVIADO_FORNECEDOR]: 'Aguardando sua resposta',
  [STATUS_ITEM.VALOR_RECEBIDO]: 'Respondida',
  [STATUS_ITEM.CRIADO_TARIFARIO]: 'Aceita',
  [STATUS_ITEM.ENCERRADA]: 'Encerrada',
  [STATUS_ITEM.RECUSADO_FORNECEDOR]: 'Recusada',
}

// id 0 = todos (o endpoint ignora statusId quando vem 0 ou ausente).
export const OPCOES_FILTRO_STATUS = [
  { id: STATUS_ITEM.ENVIADO_FORNECEDOR, descricao: 'Aguardando minha resposta' },
  { id: 0, descricao: 'Todas' },
  { id: STATUS_ITEM.VALOR_RECEBIDO, descricao: 'Respondidas' },
  { id: STATUS_ITEM.CRIADO_TARIFARIO, descricao: 'Aceitas' },
  { id: STATUS_ITEM.ENCERRADA, descricao: 'Encerradas' },
  { id: STATUS_ITEM.RECUSADO_FORNECEDOR, descricao: 'Recusadas' },
]

export function labelStatus(item: FornecedorCotacaoPortalVm): string {
  return LABEL_STATUS[item.statusId] ?? item.descricaoStatus ?? '-'
}

// O fornecedor responde uma vez só, e só enquanto o trecho e o envio estão abertos.
export function podeResponder(item: FornecedorCotacaoPortalVm): boolean {
  return (
    item.statusId === STATUS_ITEM.ENVIADO_FORNECEDOR &&
    item.cotacaoStatusId === STATUS_COTACAO_ABERTA
  )
}
